import httpService from "./httpService";
import { getUserID } from "./getLocalStorage";

export interface GiftCardPreview {
  gift_card_code: string;
  subtotal_amount: number;
  discount_amount: number;
  pay_amount: number;
  remaining_amount: number;
  remaining_after_amount: number;
}

export const previewGiftCardApi = (payload: Record<string, unknown>) => {
  return httpService.post<{ success: boolean; data: GiftCardPreview; message?: string[] }>(
    "gift-card/preview",
    {
      user_id: getUserID(),
      ...payload,
    }
  );
};
